// extracted by mini-css-extract-plugin
export default {"layout":"Policy_layout__KpxyB","start":"Policy_start__4cRfj","markdown":"Policy_markdown__f3Ax8","examples":"Policy_examples__EhhCQ"};